module.exports = __webpack_public_path__ + "static/img/4.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/4.jpg
// module id = VdFB
// module chunks = 36